<template>
  <div>
    <b-row>
      <b-col>
        <b-form-group
          id="fieldsetNumberOfRetries"
          :label-cols="4"
          breakpoint="md"
          label="Number of Retries*:"
          label-for="inputNumberOfRetries"
        >
          <b-form-input
            id="inputNumberOfRetries"
            name="inputNumberOfRetries"
            v-validate="'required|min_value:0|max_value:10'"
            type="number"
            v-model.number="entity.max_number_of_retries"
            data-vv-as="Number of Retries"
            placeholder="Number of Retries"
            :disabled="isReadonly"
          ></b-form-input>
          <span class="text-danger">{{ errors.first('inputNumberOfRetries') }}</span>
        </b-form-group>
      </b-col>
    </b-row>
    <b-row>
      <b-col>
        <b-form-group
          id="fieldsetStartDays"
          :label-cols="4"
          breakpoint="md"
          label="Retry Start Days*:"
          label-for="inputStartDays"
        >
          <b-form-input
            id="inputStartDays"
            name="inputStartDays"
            v-validate="'min_value:1|required'"
            type="number"
            v-model.number="entity.start_days"
            data-vv-as="Start Days"
            placeholder="Start Days"
            ref="StartDays"
            :disabled="isReadonly"
          ></b-form-input>
          <span class="text-danger">{{ errors.first('inputStartDays') }}</span>
        </b-form-group>
      </b-col>
    </b-row>
    <b-row>
      <b-col>
        <b-form-group
          id="fieldsetEndDays"
          :label-cols="4"
          breakpoint="md"
          label="Retry End Days*:"
          label-for="inputEndDays">
          <b-form-input
            id="inputEndDays"
            name="inputEndDays"
            v-validate="'min_value:1|isBigger:StartDays|required'"
            type="number"
            v-model.number="entity.end_days"
            data-vv-as="End Days"
            placeholder="End Days"
            :disabled="isReadonly"
          ></b-form-input>
          <span class="text-danger">{{ errors.first('inputEndDays') }}</span>
        </b-form-group>
      </b-col>
    </b-row>
  </div>
</template>
<script>
  export default {
    name: "VCopayEPARetrySetting",
    props: {
      entity: {
        required: true,
        type: Object
      },
      isReadonly: {
        required: false,
        type: Boolean
      }
    }
  };
</script>



// WEBPACK FOOTER //
// src/components/VCopayEPARetrySetting.vue